




























import Vue from 'vue';

import Component from 'vue-class-component';

import AppSearchObjectsList from 'shared/components/SearchObjectsList.vue';
import AppCompleteOrder from './CompleteOrderStep.vue';
import AppOrder from './OrderStep.vue';

import { state } from '../../util/state';
import { AppState } from '../../util/app-state';

@Component({
  name: 'AppActionStepsDialog',
  components: { AppSearchObjectsList, AppOrder, AppCompleteOrder },
})
export default class SearchObject extends Vue {
  // computed
  get state(): AppState {
    return state;
  }

  // lifecycle
  created() {
    state.step = 'search';
  }

  beforeDestroy() {
    state.step = 'form';
    state.orderItems = [];
    state.objectInfo = null;
  }

  // methods
  objectSelected(object: RealtyObject) {
    state.objectInfo = object;
    state.step = 'order';
  }

  paymentSuccess() {
    state.step = 'complete';
  }
}
